// Lib
import React from 'react';
import styled from 'styled-components';
import { Field } from 'react-final-form';
import { Flex, Text } from 'rebass';

// Theme
import colors from 'theme/colors';

const Label = styled.label`
  cursor: pointer;
  display: block;
`;

const Input = styled.input`
  opacity: 0;
  position: absolute;
  z-index: -10;
  width: 0;
  height: 0;
`;

const Circle = styled.div<any>`
  border: 1px solid ${colors.primary};
  border-color: ${props => (props.checked ? colors.primary : '')};
  border-radius: 50%;
  width: 20px;
  height: 20px;
  position: relative;
  margin-right: 5px;
  ${props =>
    props.checked &&
    `
      &::before {
        background: ${colors.primary};
        border-radius: 50%;
        content: '';
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 14px;
        height: 14px;
        margin: auto;
      }
    `}
`;

const Content = styled.div`
  overflow: hidden;
`;

interface RadioInputProps {
  value: string;
  name: string;
  defaultValue?: string;
}

const StyledRadio = ({ input }: any) => (
  <Label>
    <Flex alignItems="center">
      <Circle checked={input.checked} />
      <Content>
        <Text fontWeight={6}>{input.value}</Text>
      </Content>
    </Flex>
    <Input {...input} />
  </Label>
);

const RadioInput: React.FC<RadioInputProps> = ({ value, name, defaultValue }): JSX.Element => (
  <Field
    name={name}
    value={value}
    defaultValue={defaultValue}
    type="radio"
    component={StyledRadio}
  />
);

export default RadioInput;
